"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withChegg = withChegg;
exports.WITH_CHEGG_COMPONENT_NAME = void 0;

var _nextRio = require("@chegg-web-tools/next-rio");

var React = _interopRequireWildcard(require("react"));

var _withApollo = require("./withApollo");

var _nextOptimizely = require("@chegg-web-tools/next-optimizely");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var WITH_CHEGG_COMPONENT_NAME = 'WithCheggPageHelper';
exports.WITH_CHEGG_COMPONENT_NAME = WITH_CHEGG_COMPONENT_NAME;

function withChegg(Page) {
  var withSsr = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  if (Page.displayName == WITH_CHEGG_COMPONENT_NAME) {
    return Page;
  }

  var WrappedPage = Page;

  if (Page.displayName != _withApollo.WITH_APOLLO_COMPONENT_NAME) {
    WrappedPage = (0, _withApollo.withApollo)(Page, withSsr);
  }

  var WithChegg = function WithChegg(props) {
    (0, _nextRio.initRio)();
    return /*#__PURE__*/React.createElement(_nextOptimizely.NextOptimizely, null, /*#__PURE__*/React.createElement(WrappedPage, props));
  };

  WithChegg.getInitialProps = Page.getInitialProps;
  WithChegg.displayName = WITH_CHEGG_COMPONENT_NAME;
  return WithChegg;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-web-tools/with-chegg/dist/withChegg.js
// module id = 5688
// module chunks = 11